<template>
  <div class="home">
    <Header :isBook='!isBook' :isArrival='!getStorageInfo.storageDateEnd ? true : false'/>
    <div class="info-wrapper">
      <div class="delivery-info">
        <div class="delivery-info--content">
          <div class="orange-box">Order Details</div>
          <div class='container-info'>
            <br>
            <p>{{ getStorageInfo.storageDateEnd ? 'Storage' : getOrderInfo.from }} Service</p>
            <hr class="hr"><br>
            <div class="price-list">
              <div class="price-row">
                <p>{{ !this.getStorageInfo.storageDateEnd ? this.getAllBagsCount(true) : this.getAllBagsCount(false) }}
                  bag(s):
                </p>
                <p class="price-value">€ {{ getStateData.additionalInfo.bagsPrice }}</p>
              </div>
              <div class="price-row">
                <p>{{ getStorageInfo.numberOfHeavyBags > 0 ?
                      getStorageInfo.numberOfHeavyBags : getOrderInfo.numberOfHeavyBags }} Odd-size:</p>
                <p class="price-value">€ {{ getStateData.additionalInfo.oddSizeBagsPrice }}</p>
              </div>
              <div v-if="getStateData.additionalInfo.lateFee" class="price-row">
                <p>Later order fee:</p>
                <p class="price-value">€ {{ getStateData.additionalInfo.lateFee.toFixed(2) }}</p>
              </div>
              <div v-if="getStateData.additionalInfo.handInFee" class="price-row">
                <p>Out of office fee (hand-in):</p>
                <p class="price-value">€ {{ getStateData.additionalInfo.handInFee.toFixed(2) }}</p>
              </div>
              <div v-if="getStateData.additionalInfo.handOutFee" class="price-row">
                <p>Out of office fee (hand-out):</p>
                <p class="price-value">€ {{ getStateData.additionalInfo.handOutFee.toFixed(2) }}</p>
              </div>
              <div
                v-if="getStateData.additionalInfo.outsideOfficeFee && !getStateData.additionalInfo.handInFee && !getStateData.additionalInfo.handOutFee"
                class="price-row"
              >
                <p>Out of office hours fee:</p>
                <p class="price-value">€ {{ getStateData.additionalInfo.outsideOfficeFee.toFixed(2) }}</p>
              </div>
            </div>
            <hr class="hr"><br>
            <div class="price-row">
              <p>Total:</p>
              <p class="price-value">€ {{ priceCalculation(!getStorageInfo.storageDateEnd ? true : false) }}</p>
            </div><br>
          </div><br>
          <div><img src="../assets/images/transport_back.png"></div><br>
          <div class="buttons-container">
            <button class="btn-back" @click="$route.query.orderOnDock ? goToService('TravellerInfo', service) : goTo('TravellerInfo', service)">Back</button>
            <button class="btn-next" @click="$route.query.orderOnDock ? goToService('TermsAndConditions', service) : goTo('TermsAndConditions', service)">Pay</button>
          </div>
        </div>
      </div>
      <BasketInfo :isArrival='!getStorageInfo.storageDateEnd ? true : false' class="basket-info-hidden" />
    </div>
    <Links link-location="row" />
    <ContactUs />
  </div>
</template>

<script>
import additionalFunctions from '../mixins/additionalFunctions'
import Header from '@/components/Header'
import BasketInfo from '@/components/BasketInfo'
import Links from '@/components/TCAndPrivacyPolicyLinks'
import ContactUs from '@/components/ContactUs'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'OrderDetails',
  props: ['service'],
  components: {
    Header,
    ContactUs,
    BasketInfo,
    Links
  },
  computed: mapGetters([
    'getOrderInfo', 'getStorageInfo', 'getStateData', 'getAllBagsCount',
    'priceCalculation'
  ]),
  mixins: [additionalFunctions],
  data () {
    return {
      isBook: true
    }
  },
  mounted () {
    this.goToMainPage()
  },
  methods: {
    ...mapMutations(['goToMainPage', 'addFromTo']),
    goTo (name, service) {
      this.addFromTo({
        from: service
      })

      this.$router.push({
        name: name,
        params: {
          service: service,
          services: this.getOrderInfo.services
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  input {
    height: 40px;
  }
  p {
    margin-left: 40px;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.07rem;
    color: #53565A;
  }

  .hr {
    margin: 30px;
  }

  img {
    display: block;
    margin: 0 auto;
    width: 80%;
  }

  @media screen and (min-width: 1023px) {
    img {
      width: 40%;
    }
  }

  .price-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .price-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    column-gap: 16px;
    padding: 0 40px;
  }

  .price-row p {
    margin: 0;
  }

  .price-value {
    text-align: right;
    white-space: nowrap;
  }

  @media screen and (max-width: 480px) {
    .price-row {
      column-gap: 12px;
      padding: 0 30px;
    }
  }
</style>
